import { ecsGetPlaceFromLocationSlug } from '@/api/geo/geoServiceHttpClient';

/**
 * Get the place from a location slug via geo-service-http (ECS/Fargate).
 */
export async function getPlaceFromLocationSlug(slug: string) {
    try {
        const response = await ecsGetPlaceFromLocationSlug({ locationSlug: slug });
        return response?.['place'] || null;
    } catch (error) {
        console.error('Failed to fetch place from location slug from geo-service-http', error);
        return null;
    }
}
